import BlockDefaultTxt from './BlockDefaultTxt';
export default BlockDefaultTxt;
